export enum AnnotationChangeSource {
    /**
     * Delete action triggered programmatically.
     * Should be ignored in 'delete' event listeners.
     */
    temporaryDelete = 'temporaryDelete',
    temporaryCreate = 'temporaryCreate',
}
